// Auto generated file, do not manually modify!
// com.hotpads.rins.api.web.handler.ProofOfInsuranceWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  ProofOfInsuranceWebApiHandler_createAndShareProof,
  ProofOfInsuranceWebApiHandler_getProofStatus,
  ProofOfInsuranceWebApiHandler_getProofStatus_Path,
  ProofOfInsuranceWebApiHandler_getTenantsList,
  ProofOfInsuranceWebApiHandler_getTenantsList_Path,
  ProofOfInsuranceWebApiHandler_sendProofRequestEmail,
  ProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid,
} from '@zg-rentals/ts-rins-client';

import type {
  CreateAndShareProofWebApiRequestDto,
  EmailRequestResultDto,
  GetProofStatusWebApiRequestDto,
  GetProofStatusWebApiResponseDto,
  GetTenantsListWebApiRequestDto,
  GetTenantsListWebApiResponseDto,
  SendProofRequestWebApiRequestDto,
  ValidateRenterProofAndLinkZuidWebApiRequestDto,
} from '@zg-rentals/ts-rins-client';

export interface ProofOfInsuranceWebApiHandler_createAndShareProof_Args {
  postData: CreateAndShareProofWebApiRequestDto;
}

export type ProofOfInsuranceWebApiHandler_createAndShareProof_Options = UseMutationOptions<
  void,
  unknown,
  ProofOfInsuranceWebApiHandler_createAndShareProof_Args
>;

/**
 * create proof of insurance with zDoc document ID,share proof of insurance and notify email recipient
 */
export const useProofOfInsuranceWebApiHandler_createAndShareProof = ({
  httpClient,
  ...options
}: Omit<ProofOfInsuranceWebApiHandler_createAndShareProof_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ProofOfInsuranceWebApiHandler_createAndShareProof_Args) =>
      ProofOfInsuranceWebApiHandler_createAndShareProof(args.postData, httpClient),
  });
};

export type ProofOfInsuranceWebApiHandler_getProofStatus_Options = UseQueryOptions<
  GetProofStatusWebApiResponseDto,
  unknown,
  GetProofStatusWebApiResponseDto,
  Array<string | GetProofStatusWebApiRequestDto>
>;

const ProofOfInsuranceWebApiHandler_getProofStatus_GetKey = (postData: GetProofStatusWebApiRequestDto) => [
  ProofOfInsuranceWebApiHandler_getProofStatus_Path,
  postData,
];

/**
 * get proof of insurance state for tenant
 */
export const useProofOfInsuranceWebApiHandler_getProofStatus = (
  postData: GetProofStatusWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<ProofOfInsuranceWebApiHandler_getProofStatus_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ProofOfInsuranceWebApiHandler_getProofStatus_GetKey(postData),
    queryFn: () => ProofOfInsuranceWebApiHandler_getProofStatus(postData, httpClient),
  });
};
useProofOfInsuranceWebApiHandler_getProofStatus.getKey = ProofOfInsuranceWebApiHandler_getProofStatus_GetKey;

export type ProofOfInsuranceWebApiHandler_getTenantsList_Options = UseQueryOptions<
  GetTenantsListWebApiResponseDto,
  unknown,
  GetTenantsListWebApiResponseDto,
  Array<string | GetTenantsListWebApiRequestDto>
>;

const ProofOfInsuranceWebApiHandler_getTenantsList_GetKey = (postData: GetTenantsListWebApiRequestDto) => [
  ProofOfInsuranceWebApiHandler_getTenantsList_Path,
  postData,
];

/**
 * Get a list of tenants with the request status
 */
export const useProofOfInsuranceWebApiHandler_getTenantsList = (
  postData: GetTenantsListWebApiRequestDto,
  {
    httpClient,
    ...options
  }: Omit<ProofOfInsuranceWebApiHandler_getTenantsList_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: ProofOfInsuranceWebApiHandler_getTenantsList_GetKey(postData),
    queryFn: () => ProofOfInsuranceWebApiHandler_getTenantsList(postData, httpClient),
  });
};
useProofOfInsuranceWebApiHandler_getTenantsList.getKey = ProofOfInsuranceWebApiHandler_getTenantsList_GetKey;

export interface ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Args {
  postData: SendProofRequestWebApiRequestDto;
}

export type ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Options = UseMutationOptions<
  EmailRequestResultDto,
  unknown,
  ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Args
>;

/**
 * Send an email reminder to Rachels to upload their proof of insurance
 */
export const useProofOfInsuranceWebApiHandler_sendProofRequestEmail = ({
  httpClient,
  ...options
}: Omit<ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ProofOfInsuranceWebApiHandler_sendProofRequestEmail_Args) =>
      ProofOfInsuranceWebApiHandler_sendProofRequestEmail(args.postData, httpClient),
  });
};

export interface ProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid_Args {
  postData: ValidateRenterProofAndLinkZuidWebApiRequestDto;
}

export type ProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid_Options = UseMutationOptions<
  void,
  unknown,
  ProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid_Args
>;

/**
 * Validate proof request to renter info, and links ZUID to the proof request if needed
 */
export const useProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid = ({
  httpClient,
  ...options
}: Omit<ProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid_Args) =>
      ProofOfInsuranceWebApiHandler_validateRenterProofAndLinkZuid(args.postData, httpClient),
  });
};
